import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Header from "../components/Header"
import Layout from "../components/Layout"
import { btn, btnPrimary } from "../ds/button.module.css"
import { WhiteArrowRight } from "../ds/Shapes"

export default function index() {
  return (
    <Layout
      title="Event Networking Through Photos - AI Connection Platform"
      description="Empower attendees to create connections through photos. Revolutionary networking app with AI-powered visual engagement."
      keywords={[
        "event networking app, networking through photos, photo connection platform, visual networking events, AI photo networking, attendee photo sharing, social networking events, photo-based connections, event community app, networking via photos, visual engagement platform, photo-driven networking, AI networking solution, connection through images, event social platform",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Event Networking", url: "/event-networking-app/" },
      ]}
    >
      <div className="">
        <div className="" style={{ backgroundColor: "#7251F4" }}>
          <Header isWhiteLogo />
        </div>

        <section className="py-10" style={{ backgroundColor: "#7251F4" }}>
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <div className="md:flex items-center">
              <div className="md:w-1/2 flex flex-col justify-center text-left">
                {/* <h1 className="text-3xl md:text-5xl font-bold mb-4 text-white"><span style={{ color: '#61F2C2' }}>DOUBLE</span> YOUR <br />ATTENDEES</h1> */}
                <h1 className="text-3xl md:text-5xl font-bold mb-4 text-white">
                  AI-Powered Networking for Unmatched Event Engagement
                </h1>
                <p className="text-white">
                  Empower your attendees to create
                  <br />
                  <span style={{ color: "#61F2C2" }}>
                    connections through photos.
                  </span>
                </p>
                <Link
                  to="/request-a-demo/"
                  className={`${btn} ${btnPrimary} text-xs mt-10 md:mt-32 mb-10 md:mb-0 relative w-max group`}
                >
                  <span className="mr-4 ml-2">Show me how</span>
                  <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
                </Link>
              </div>
              <div className="md:w-1/2 md:ml-0 relative">
                <div className="text-center">
                  <StaticImage
                    src="../images/ripple_hero_1.png"
                    alt="event-networking-app-photo-ai-hero"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="md:pt-10">
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <div className="flex flex-col md:flex-row flex-col-reverse">
              <div className="md:w-1/2 flex flex-col justify-center text-left md:pr-10 md:mt-0">
                <h4
                  className="font-bold text-2xl mb-5"
                  style={{ color: "#7251F4" }}
                >
                  How it works
                </h4>
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-4"
                  style={{ color: "#7251F4" }}
                >
                  How does smart event <br />
                  networking drive{" "}
                  <span style={{ color: "#FF6550" }}>attendee engagement?</span>
                </h2>
                <p>
                  Whether it’s sharing expertise, connecting with peers, or
                  gathering leads, Premagic has the right technology to support
                  your next networking event.
                </p>
                <Link
                  to="/request-a-demo/"
                  className={`${btn} ${btnPrimary} text-xs mt-10 mb-10 md:mb-0 relative w-max group`}
                >
                  <span className="mr-4 ml-2">Show me how</span>
                  <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
                </Link>
              </div>
              <div className="md:w-1/2 md:pl-10 mt-10 md:mt-0 -mr-10 md:mr-0">
                <StaticImage
                  src="../images/ripple_how_it_works.png"
                  height={500}
                  alt="event-networking-app-photo-ai-how-it-work"
                />
              </div>
            </div>
            <div className="md:flex mt-20">
              <div className="md:w-1/2 md:pr-10">
                <StaticImage
                  src="../images/ripple_hiw_1.png"
                  alt="event-networking-app-photo-ai-ripple"
                />
              </div>
              <div className="md:w-1/2 flex flex-col justify-center text-left mt-10 md:mt-0 md:pl-10">
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Connect via faces
                </h2>
                <p className="md:pr-32">
                  Help attendees easily connect with others by tapping on any
                  face in the photo gallery to instantly access attendee
                  information.
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row mt-20 md:my-20 flex-col-reverse">
              <div className="md:w-1/2 flex flex-col justify-center text-left md:pr-10 mt-10 md:mt-0">
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Social Media Integration
                </h2>
                <p className="md:pr-32">
                  Attendees can create rich personal profiles by listing
                  relevant information and integrating multiple social profiles
                  to unlock better networking opportunities.{" "}
                </p>
              </div>
              <div className="md:w-1/2 md:pl-10">
                <StaticImage
                  src="../images/ripple_hiw_2.png"
                  alt="event-networking-app-photo-ai-social-media-integration"
                />
              </div>
            </div>
            <div className="md:flex mb-20 mt-20 md:mt-0">
              <div className="md:w-1/2 md:pr-10">
                <StaticImage
                  src="../images/ripple_hiw_3.png"
                  alt="event-networking-app-photo-ai-engaging"
                />
              </div>
              <div className="md:w-1/2 flex flex-col justify-center text-left md:pl-10 mt-10 md:mt-0">
                <h2
                  className="text-3xl md:text-4xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Engaging Value Proposition
                </h2>
                <p className="md:pr-32">
                  Stand out with a unique value proposition that increases
                  engagement and ROI. Sell more meeting packages to suppliers,
                  sponsorship opportunities to sponsors and leads to exhibitors
                </p>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="px-5 md:px-0 mx-auto pt-20 pb-20 md:w-[1080px]">
            <div className="md:flex items-center">
              <div className="md:w-1/3 md:px-2 mb-20 md:mb-0">
                <StaticImage
                  className="md:w-64 rounded-xl"
                  src="../images/ripple_ftrs_1.png"
                  alt="event-networking-app-photo-ai-increase-engagement"
                />
                <h2
                  className="text-2xl mt-7 mb-4 md:text-2xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Increase Engagement
                </h2>
                <p className="md:pr-32">
                  Boost event satisfaction by making great networking
                  opportunities a key part of the experience.
                </p>
              </div>
              <div className="md:w-1/3 md:px-10 mb-20 md:mb-0">
                <StaticImage
                  className="md:w-[273px] rounded-xl"
                  src="../images/ripple_ftrs_2.png"
                  alt="event-networking-app-photo-ai-business-card"
                />
                <h2
                  className="text-2xl mt-7 mb-4 md:text-2xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Beyond Business Cards
                </h2>
                <p className="">
                  No external app required, connect with other attendees
                  effortlessly through their LinkedIn profiles.
                </p>
              </div>
              <div className="md:w-1/3 md:pl-20">
                <StaticImage
                  className="md:w-64 rounded-xl"
                  src="../images/ripple_ftrs_3.png"
                  alt="event-networking-app-photo-ai-boost-roi"
                />
                <h2
                  className="text-2xl mt-7 mb-4 md:text-2xl font-bold md:leading-snug mb-2"
                  style={{ color: "#7251F4" }}
                >
                  Boost ROI
                </h2>
                <p className="">
                  Sell more sponsorship opportunities to sponsors, leads to
                  exhibitors & networking prospects to attendees.
                </p>
              </div>
            </div>
            <div className="text-center">
              <Link
                to="/request-a-demo/"
                className={`${btn} ${btnPrimary} text-xs mt-10 mb-10 md:mb-0 mx-auto relative w-max group`}
              >
                <span className="mr-4 ml-2">Show me how</span>
                <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
              </Link>
            </div>
          </div>
        </section>

        <section
          className="py-20 md:py-0"
          style={{ backgroundColor: "#7251F4" }}
        >
          <div className="px-5 md:px-0 mx-auto md:flex py-10 items-center md:w-[1080px]">
            <div className="md:w-1/2 flex flex-col justify-center relative mb-20 md:mb-0">
              <StaticImage
                class=""
                src="../images/posters.png"
                alt="event-networking-app-photo-ai-poster"
              />
            </div>
            <div className="md:w-1/2">
              <h4 className="text-white text-center text-2xl">
                <span style={{ color: "#61F2C2" }}>“</span>I’ve never seen a
                networking module as innovative as this! It compliments the
                experience that we design and strive to deliver for all of our
                attendees.<span style={{ color: "#61F2C2" }}>”</span>
              </h4>
              <h5
                className="text-2xl text-center mt-10"
                style={{ color: "#61F2C2" }}
              >
                Malavika Velayanikal
              </h5>
              <p className="text-white text-xl text-center">
                Director of Initiatives & Events SaaSBOOMi
              </p>
            </div>
          </div>
        </section>

        <section className="my-20">
          <div className="px-5 md:px-0 mx-auto flex py-10 items-center flex-wrap md:w-[1080px]">
            <div className="w-1/2 mb-20 md:mb-0 md:w-1/4 text-center">
              <StaticImage
                class="w-24"
                src="../images/ripple_ico_1.png"
                alt="event-networking-app-photo-ai-connection"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                5K
              </h4>
              <p>
                connections
                <br />
                powered
              </p>
            </div>
            <div className="w-1/2 mb-20 md:mb-0 md:w-1/4 text-center">
              <StaticImage
                class="w-20"
                src="../images/ripple_ico_2.png"
                alt="event-networking-app-photo-ai-events"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                700K
              </h4>
              <p>
                events
                <br />
                powered
              </p>
            </div>
            <div className="w-1/2 md:w-1/4 text-center">
              <StaticImage
                class="w-20"
                src="../images/ripple_ico_3.png"
                alt="event-networking-app-photo-ai-attendee-engagement"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                70%
              </h4>
              <p>
                increase in <br />
                attendee engagement
              </p>
            </div>
            <div className="w-1/2 md:w-1/4 text-center">
              <StaticImage
                class="w-24"
                src="../images/ripple_ico_4.png"
                alt="event-networking-app-photo-ai-roi"
              />
              <h4
                style={{ color: "#FF6550" }}
                className="text-4xl font-bold my-5"
              >
                80%
              </h4>
              <p>
                increase in
                <br />
                ROI
              </p>
            </div>
          </div>
        </section>

        {/* <RequestDemo /> */}

        {/* Cross-links to related products */}
        <section className="py-16 bg-gray-50">
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-black mb-10">
              Explore More Premagic Products
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link to="/smart-photo-distribution-for-seamless-events/" className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100">
                <h3 className="font-bold text-lg text-black mb-2">Photo Distribution</h3>
                <p className="text-sm text-gray-600">AI-powered facial recognition delivers event photos instantly to every attendee.</p>
              </Link>
              <Link to="/create-event-marketing-posters/" className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100">
                <h3 className="font-bold text-lg text-black mb-2">Marketing Posters</h3>
                <p className="text-sm text-gray-600">Create personalized, shareable posters that turn attendees into promoters.</p>
              </Link>
              <Link to="/avatar-studio/" className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100">
                <h3 className="font-bold text-lg text-black mb-2">Avatar Studio</h3>
                <p className="text-sm text-gray-600">AI-generated branded avatars that attendees love to share on social media.</p>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}
